import React from 'react';
import './styles.css';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  dados: any[]; // Substitua 'any[]' pelo tipo correto dos seus dados
}

const Paginacao: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  setCurrentPage,
  dados,
}) => {
  // Função para gerar os números de página a serem exibidos
  const getPageNumbers = () => {
    const maxPagesToShow = 5; // Número máximo de páginas a serem exibidas
    
    if (totalPages <= maxPagesToShow) {
      // Se o total de páginas for menor ou igual ao máximo, mostra todas
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    
    // Caso contrário, mostra um subconjunto de páginas
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = startPage + maxPagesToShow - 1;
    
    // Ajusta se estiver próximo do final
    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }
    
    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  };
  
  const pageNumbers = getPageNumbers();
  
  // Função para lidar com a mudança de página com preventDefault
  const handlePageChange = (e: React.MouseEvent, page: number) => {
    e.preventDefault();
    e.stopPropagation();
    setCurrentPage(page);
  };
  
  return (
    <div className="pagination-container">
      {/* <div className="pagination-info">
        {dados.length > 0 ? (
          <span>
            Mostrando {dados.length <= 10 ? 1 : (currentPage - 1) * 10 + 1} - {Math.min(dados.length, currentPage * 10)} de {dados.length} registros
          </span>
        ) : (
          <span>Nenhum registro encontrado</span>
        )}
      </div> */}
      
      {/* Exibir a paginação mesmo quando há apenas uma página */}
      <div className="d-flex justify-content-center">
        <nav>
          <ul className={`pagination ${totalPages <= 1 ? 'pagination-single-page' : ''}`}>
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <button 
                className="page-link" 
                onClick={(e) => handlePageChange(e, currentPage - 1)}
                disabled={currentPage === 1}
              >
                Anterior
              </button>
            </li>
            
            {/* Primeira página e ellipsis, se necessário */}
            {pageNumbers[0] > 1 && (
              <>
                <li className="page-item">
                  <button className="page-link" onClick={(e) => handlePageChange(e, 1)}>1</button>
                </li>
                {pageNumbers[0] > 2 && (
                  <li className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                )}
              </>
            )}
            
            {/* Páginas visíveis */}
            {pageNumbers.map((pageNumber) => (
              <li 
                key={pageNumber} 
                className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}
              >
                <button
                  className="page-link"
                  onClick={(e) => handlePageChange(e, pageNumber)}
                >
                  {pageNumber}
                </button>
              </li>
            ))}
            
            {/* Última página e ellipsis, se necessário */}
            {pageNumbers[pageNumbers.length - 1] < totalPages && (
              <>
                {pageNumbers[pageNumbers.length - 1] < totalPages - 1 && (
                  <li className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                )}
                <li className="page-item">
                  <button className="page-link" onClick={(e) => handlePageChange(e, totalPages)}>
                    {totalPages}
                  </button>
                </li>
              </>
            )}
            
            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
              <button 
                className="page-link" 
                onClick={(e) => handlePageChange(e, currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Próximo
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Paginacao;
